import React, { useMemo, useState } from 'react'
import { IonCheckbox, IonImg, IonInput, IonPage, IonSlide, IonSlides, IonPopover, useIonViewWillEnter } from '@ionic/react'
import { RouteComponentProps } from 'react-router-dom'
import { MktButton, AvatarModal } from '@cps'
import { modalLayer, useHistoryNew, setVisitorInfo, getVisitorInfo, filterNickname } from '@utils'
import { memberMobx, multiPersonMobx } from '@mobxStore'
import { getCommonResourcesPath } from '@env'
import banner1 from '@img/mkt/banner1.png'
import banner2 from '@img/mkt/banner2.png'
import './index.scss'

interface IProps extends IPage, RouteComponentProps { }

const getRandomName = () => {
  return `${i18n.t('mkt.login.guest')}${Math.random().toString().substring(2, 6)}`
}

const getInfo = () => {
  const info = getVisitorInfo()
  return info || {
    name: '',
    avatar: '',
    isSave: 1,
  }
}

const FirstPage: React.FC<IProps> = (props) => {
  const { match } = props
  const history = useHistoryNew()
  const [info, setInfo] = useState(getInfo())
  const [event, setEvent] = useState<any>()
  const [defaultName, setDefaultName] = useState<string>('')
  const _data: string[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11']
  let newRandomImg: any = ''
  const generatePicUrl = (personList: Array<any>) => {
    const userName = personList.map((item) => {
      return item.avatar
    })
    const set = new Set(userName)
    const otherImg = _data.find((e) => {
      return !set.has(`${getCommonResourcesPath('image')}/avatar/avatar${_data[e]}.png`)
    })
    newRandomImg = otherImg ? `${getCommonResourcesPath('image')}/avatar/avatar${_data[otherImg]}.png` : ''
  }
  const mySlides = useMemo(() => (
    <IonSlides options={{
      autoplay: true
    }}
    >
      <IonSlide>
        <IonImg src={banner1}></IonImg>
      </IonSlide>
      <IonSlide>
        <IonImg src={banner2}></IonImg>
      </IonSlide>
    </IonSlides>
  ), [])
  // 设置游客的初始信息
  const handleJoin = () => {
    setVisitorInfo({
      ...info,
      name: info.name || defaultName,
    })

    const visitorInfo = getInfo()
    multiPersonMobx.setCurrentPersonInfo({
      personId: visitorInfo?.id,
      nickName: visitorInfo?.name || defaultName,
      avatar: visitorInfo?.avatar,
      personType: 'visitor',
    })

    history.goBack()
  }
  const changeAvatar = () => {
    modalLayer(AvatarModal, { name: info.name || defaultName, data: info.avatar }).then((val: any) => {
      setInfo({ ...info, avatar: val || '' })
    })
  }
  useIonViewWillEnter(() => {
    setDefaultName(getRandomName())
    // if (memberMobx.isLogin) {
    // history.goBack()
    // }
  })

  return (
    <IonPage className='my-first-page'>
      <div className='my-first-page-container'>
        <div className='container'>
          <div className='banner'>
            {mySlides}
            <div className='tips'>{i18n.t('mkt.login.tips')}</div>
          </div>
          <div className='first-page-form'>
            <div className='first-page-header'>
              <h2 className='first-page-title'>{i18n.t('mkt.login.visitorTitle')}</h2>
              {!memberMobx.isLogin && (
                <div className='first-page-btn'>
                  <span className='link-btn' onClick={() => history.push('/login')}>{i18n.t('mkt.login.loginOrRegister')}</span>
                </div>
              )}
            </div>
            <div className='first-page-avatar-box'>
              <div className='avatar'>{info.avatar ? <IonImg src={info.avatar}></IonImg> : (info.name || defaultName)?.charAt(0)}</div>
              <div className='link-btn' onClick={changeAvatar}>{i18n.t('mkt.login.changeAvatar')}</div>
            </div>
            <div className='name-bar'>
              <i className='iconfont icon-my-circle'></i>
              <IonInput onIonChange={(e) => { setInfo({ ...info, name: filterNickname(e.detail.value) }) }} placeholder={defaultName} value={info.name}></IonInput>
            </div>
            <div className='cookie-info-bar' style={{ display: (bo !== 'cn') ? 'none' : 'block' }}>
              <IonCheckbox
                checked={info.isSave === 1} onIonChange={({ detail }) => setInfo({
                  ...info,
                  isSave: detail.checked ? 1 : 0
                })}
              >
              </IonCheckbox>
              {i18n.t('mkt.login.saveCookie')}
              <span className='link-btn' style={{ marginLeft: 4 }} onClick={e => setEvent(e)}>{i18n.t('mkt.login.detail')}</span>
              <IonPopover
                cssClass='cart-tips-popover'
                event={event}
                isOpen={!!event}
                onDidDismiss={() =>
                  setEvent(undefined)}
              >
                <p>{i18n.t('mkt.login.saveCookieTips')}</p>
                <span
                  onClick={(e: any) => {
                    e.persist()
                    setEvent(undefined)
                  }}
                >
                  {i18n.t('newCart.know')}
                </span>
              </IonPopover>
            </div>
          </div>
        </div>
        <div className='btn-ctn'>
          {!!(match.params as any).type && <div className='cancel-btn' style={{ marginRight: 16 }} onClick={() => history.goBack()}>{i18n.t('mkt.common.cancel')}</div>}
          <MktButton insideStyle={{ flex: 1 }} onClick={handleJoin}>{i18n.t((match.params as any).type ? 'mkt.login.confirm' : 'mkt.login.join')}</MktButton>
        </div>
      </div>
    </IonPage>
  )
}

export default FirstPage
